import { render, staticRenderFns } from "./Gifts.vue?vue&type=template&id=371560fa"
import script from "./Gifts.vue?vue&type=script&lang=js"
export * from "./Gifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports